import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { manualTypeConfig } from './manualTypeConfig';
import { createManualTypeValidationSchema } from './manualTypeValidation';

const { config: initializedConfig } = initializeModule(
  manualTypeConfig,
  createManualTypeValidationSchema,
);

const ManualTypePage = createModulePage(initializedConfig, {
  displayName: 'ManualTypePage',
  description: 'Manual type catalog for multi-select classification',
});

export default ManualTypePage;
